import { Box, ButtonBase, Typography, makeStyles } from "@material-ui/core";
import ChevronRight from "@material-ui/icons/ChevronRight";
import React from "react";

import { InvestmentStyleDiagnosis } from "@/api/generated";
import { homeCardStyle } from "@/components/home/HomeSection";
import { layoutTokens, semanticColors, textStyles } from "@/designTokens";
import { useDevice } from "@/hooks/useDevice";
import { buildStance, buildTypeDisplay } from "@/utilities/resultLabels";

const useStyles = makeStyles({
  banner: {
    ...homeCardStyle,
    display: "flex",
    alignItems: "center",
    gap: layoutTokens.space[16],
    padding: `${layoutTokens.space[12]}px ${layoutTokens.space[16]}px`,
    width: "100%",
    textAlign: "left",
  },
  character: { width: 64, height: 64, objectFit: "contain", flexShrink: 0 },
  texts: { display: "flex", flexDirection: "column", gap: layoutTokens.space[4], flexGrow: 1, minWidth: 0 },
  label: { ...textStyles["PC/Label/H6"], color: semanticColors["text/secondary"] },
  headline: { ...textStyles["SP/Heading/H3"], color: semanticColors["text/primary"] },
  description: { ...textStyles["SP/Body/Large"], color: semanticColors["text/secondary"], overflowWrap: "anywhere" },
  pcDescription: { ...textStyles["PC/Body/Large"] },
  capRow: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: layoutTokens.space[8] },
  arrow: { fontSize: 20, color: semanticColors["icon/primary"], flexShrink: 0, alignSelf: "flex-start" },
});

export const InvestmentStyleSummarySection: React.FC<{
  diagnosis: InvestmentStyleDiagnosis | null;
  onClick: () => void;
}> = ({ diagnosis, onClick }) => {
  const classes = useStyles();
  const { isMobile } = useDevice();
  const { label, headline, character } = buildTypeDisplay(diagnosis);
  const description = diagnosis
    ? buildStance(diagnosis)
    : "3分の質問に答えると、あなたの投資方針書ができあがり、相性の良いプランナーがわかります。";
  return (
    <ButtonBase className={classes.banner} onClick={onClick}>
      <img className={classes.character} src={character} alt="" />
      <Box className={classes.texts}>
        <Box className={classes.capRow}>
          <Typography className={classes.label}>{diagnosis ? label : "投資スタイル診断"}</Typography>
          <ChevronRight className={classes.arrow} />
        </Box>
        <Typography className={classes.headline}>{diagnosis ? headline : "まだ診断していません"}</Typography>
        {description && (
          <Typography className={`${classes.description} ${isMobile ? "" : classes.pcDescription}`}>
            {description}
          </Typography>
        )}
      </Box>
    </ButtonBase>
  );
};
